/*
This file is located in the main branch
Last time the file was updated (UTC): [02.07.2024 18:53:01]
Permissions to update outside the main branch: [false]
*/

import { DropdownFilterButton } from '@finbeat/react-toolkit';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import { useQuestionaryWorkplaceState } from './Questionary';

type QuestionaryAddButtonProps = {
    showModal: () => void;
};

const QuestionaryAddButton = ({ showModal }: QuestionaryAddButtonProps) => {
    const { setSelectedItem: setCurrentItem } = useQuestionaryWorkplaceState();

    return (
        <DropdownFilterButton
            onClick={() => {
                setCurrentItem(null);
                showModal();
            }}
            icon={faPlus}
            disabled={false}
            title="BackOfficeAdd"
        />
    );
};

export default QuestionaryAddButton;
